import React, { Component } from "react";
import { BsFileEarmarkArrowDown, BsFileEarmarkArrowUp } from "react-icons/bs";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FiTrash2 } from "react-icons/fi";
import { CommmonService } from "app/_services/CommonService/CommonService";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";
import { NotificationContainer, NotificationManager } from "react-notifications";
import Loader from "../Loader/Loader";
import { SetPermission } from "app/Components/SetPermission/Permissions";
import toastr from "toastr";

class SingleFileUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alias: "",
      isLoading: false,
    };
  }

  onFileChange = async (e) => {
    const target = e.target;

    if (e.target.files[0]) {
      if (this.maxSelectFile(e)) {
        let selectedFile = e.target.files[0];
        let check = selectedFile.name.split(".");
        if (this.props.check) {
          let extention = check[check.length - 1];
          if (this.props.check.includes(extention)) {
          } else {
            toastr.warning(`Only ${this.props.check.join(", ")} format allowed`);
            return false;
          }
        }
        if (selectedFile) {
          this.setState({ isLoading: true });

          const formData = new FormData();

          formData.append("alias", this.state.alias);
          formData.append("file", selectedFile);

          let fileUploadResponse = await CommmonService.uploadDocument(formData);
          if (fileUploadResponse && fileUploadResponse.status) {
            this.props.onFileChange(e, fileUploadResponse.data, this.props.name);
            this.setState({
              alias: "",
              isLoading: false,
            });
          } else {
            this.setState({
              isLoading: false,
            });
          }
        }
      }
    }
    target.value = null;
  };

  maxSelectFile = (event) => {
    let selectedFile = this.props.selectedFile; // create file object
    if (selectedFile && Object.keys(selectedFile).length > 0) {
      const msg = "Only one file can be uploaded at a time";

      NotificationManager.info(msg);
      event.target.value = null; // discard selected file
      this.setState({
        selectedFileError: msg,
      });
      return false;
    } else {
      this.setState({
        selectedFileError: "",
      });
    }
    return true;
  };

  deleteDocumentFile = (e) => {
    e.preventDefault();
    this.props.deleteDocumentFile(e, this.props.name);
  };

  handleInputChange = (e) => {
    const { value } = e.target;
    this.setState({
      alias: value,
    });
  };

  render() {
    let { error, submitted, labelName, selectedFile } = this.props;

    let { isLoading } = this.state;

    console.log("selectedFile", selectedFile);

    return (
      <div
        className={this.props.clsName ? this.props.clsName : "col-md-4 form-group mb-3"}
      >
        <Loader loading={isLoading}></Loader>
        <label>{this.props.nonlabel ? "" : labelName ? labelName : "Alias"}</label>
        <div className="alias_docUpload">
          {this.props.alias === false ? (
            ""
          ) : (
            <input
              type="text"
              class="form-control"
              placeholder="Enter alias name"
              value={this.state.alias}
              onChange={(e) => this.handleInputChange(e)}
            />
          )}

          {this.props.hideInput !== true && (
            <div className="uploadFileBtn">
              <label htmlFor="upload-single-file">
                <BsFileEarmarkArrowUp />
              </label>
              <input
                disabled={this.props.disabled === true}
                className="uploadFile"
                type="file"
                onChange={(e) => this.onFileChange(e)}
              ></input>
            </div>
          )}
        </div>
        {selectedFile && Object.keys(selectedFile).length > 0 && (
          <div className="uploadedFilesList">
            <div className="uploadedFilesListInner">
              <span> {selectedFile.alias ? selectedFile.alias : ""}</span>
              <div className="uploadIconsGroup">
                {this.props.permission !== "" &&
                this.props.permission !== undefined &&
                this.props.permission !== null ? (
                  <SetPermission
                    permission={this.props.permission}
                    data={
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="tooltip-top">
                            {selectedFile.real_document_name}
                          </Tooltip>
                        }
                      >
                        <a
                          href={URL_CONFIG.IMG_URL + selectedFile.document_name}
                          className="icons text-cyanBlue"
                        >
                          <BsFileEarmarkArrowDown />
                        </a>
                      </OverlayTrigger>
                    }
                  ></SetPermission>
                ) : (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="tooltip-top">
                        {selectedFile.real_document_name}
                      </Tooltip>
                    }
                  >
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={URL_CONFIG.DEV_URL + "uploads/" + selectedFile.document_name}
                      className="icons text-cyanBlue"
                    >
                      <BsFileEarmarkArrowDown />
                    </a>
                  </OverlayTrigger>
                )}

                {!this.props.disabled && (
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">{"Delete Document"}</Tooltip>}
                  >
                    <a
                      href
                      className="icons text-danger"
                      onClick={(e) => this.deleteDocumentFile(e)}
                    >
                      <FiTrash2 />
                    </a>
                  </OverlayTrigger>
                )}
              </div>
            </div>
          </div>
        )}

        {submitted && error && error.selectedFile !== "" && (
          <div className="fromerror">{error.selectedFile}</div>
        )}
        <NotificationContainer />
      </div>
    );
  }
}

export default SingleFileUpload;
